// extracted by mini-css-extract-plugin
module.exports = {"root":"BillingDetails_root__3cJsy","subscription":"BillingDetails_subscription__Ed5A9","paymentFailed":"BillingDetails_paymentFailed__2vQZB"};